import { defineStore } from 'pinia'
import InvoiceStore, { InvoiceState } from '@/modules/invoice/types/store/InvoiceStore'
import InvoiceItem from '@/modules/invoice/entities/InvoiceItem'
import ContactInfo from '@/modules/invoice/entities/ContactInfo'
import InvoiceUserDataInfo from '@/modules/invoice/entities/InvoiceUserDataInfo'

export const useInvoiceStore: InvoiceStore = defineStore('invoice', {
  state: () =>
    ({
      invoice: null,
      contactInfo: null,
      contactVat: null,
      invoiceUserDataInfo: null,
      countryList: null,
      isInvoiceLoading: false,
    }) as InvoiceState,
  getters: {
    getInvoiceObject() {
      return this.invoice
    },
    getInvoiceItems() {
      return this.getInvoiceObject?.items ?? []
    },
    getInvoiceTransactions() {
      return this.getInvoiceObject?.transactions ?? []
    },
    getInvoiceDeclinedTransactions() {
      return this.getInvoiceObject?.declinedTransactionsInfo ?? []
    },
    getContactInfoObject() {
      return this.contactInfo
    },
    getContactVatString() {
      return this.contactVat
    },
    getInvoiceUserData() {
      return this.invoiceUserDataInfo ?? null
    },
    getCountries() {
      return this.countryList ?? null
    },
    isMassPayment() {
      return this.getInvoiceObject?.massPayInvoice
    },
  },
  actions: {
    async getInvoice(id) {
      this.invoice = null
      const response = await this.$services.invoice.loadInvoice(id)
      this.invoice = new InvoiceItem(response)
    },
    async getContactInfo() {
      const response = await this.$services.invoice.loadContactInfo()
      this.contactInfo = new ContactInfo(JSON.parse(response.value))
    },
    async getContactVat() {
      const response = await this.$services.invoice.loadContactVat()
      this.contactVat = String(response.data.value).replace(/"/g, '')
    },
    async getInvoiceUserDataInfo(id) {
      const response = await this.$services.invoice.loadInvoiceUserDataInfo(id)
      this.invoiceUserDataInfo = new InvoiceUserDataInfo(response)
    },
    async getCountryList() {
      const response = await this.$services.invoice.loadCountryList()
      this.countryList = response.countries
    },
    async payByCredit(req) {
      await this.$services.invoice.payByCredit(req)
    },
    async getInvoicePdf(id) {
      return await this.$services.invoice.loadInvoicePdf(id)
    },
  },
})
